/*
 * @Author: your name
 * @Date: 2020-08-08 17:21:23
 * @LastEditTime: 2020-08-14 17:43:39
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/router/theme.guard.js
 */

import router from './index'
import store from '@/store'
import apis from '@/api'
import Vue from 'vue'

const writeList = [
  'workbench',
  'app-message'
]

router.beforeResolve((to, from, next) => {
  if (to.query.appId && !writeList.includes(to.name)) {
    // Vue.prototype.$loading.show()
    // 获取网络请求
    const request = {
      ...apis.APP_PAGE.QUERY_APP_INFO,
      params: {
        appId: to.query.appId
      }
    }
    Vue.prototype.$request(request).asyncThen((resp) => {
      Vue.prototype.$loading.hide()
      next()
      store.commit('themeModule/SET_CURRENT_THEME_COLOR', {
        app: resp.data.appId,
        color: resp.data.appTheme
      })
      store.commit('themeModule/SET_ROLE_LIST', {
        roleList: resp.data.roles
      })
    }, (error) => {
      Vue.prototype.$loading.hide()
      next()
      store.commit('themeModule/SET_DEFAULT_THEME_COLOR')
    }).asyncErrorCatch(error => {
      Vue.prototype.$loading.hide()
      next()
      store.commit('themeModule/SET_DEFAULT_THEME_COLOR')
    })
  } else {
    next()
    store.commit('themeModule/SET_DEFAULT_THEME_COLOR')
  }
})
